import HTTP from '@/utils/http';

const defaultState = () => ({
    permissions: [],
});

const permissionsModule = {
    namespaced: true,
    state: defaultState(),
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        SET(state, { permissions }) {
            state.permissions = permissions;
        },
    },
    actions: {
        RESET_STATE({ commit }) {
            commit('RESET_STATE');
        },
        GET({ commit }) {
            return HTTP({
                url: 'permissions',
            }).then((response) => {
                commit('SET', { permissions: response.data.data });
                return response.data.data;
            });
        },
    },
    getters: {
        permissions: state => state.permissions,
        editor: state => state.permissions.find(permission => permission.slug === 'editor'),
        viewer: state => state.permissions.find(permission => permission.slug === 'viewer'),
    },
};

export default permissionsModule;
